import * as types from './mutation-types'

export default {
  [types.AUTH_LOGIN] (state, payload) {
    state.user = payload
    state.role = payload.user_role
  },

  [types.AUTH_LOGOUT] (state, payload) {
    state.user = payload
    state.role = payload
    state.token = null
  },

  [types.VALIDATION] (state, payload) {
    state.validations = payload.validation
  }

}
